import * as Icons from "lucide-react";
import { DIFFERENTIALS } from "@/lib/site";
import { Reveal, Stagger, StaggerItem } from "@/lib/motion";

export const Differentials = () => (
  <section id="diferenciais" className="relative overflow-hidden bg-[#012a60] py-24 lg:py-32">
    <div className="grain" />
    <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-[#55c0e0]/20 blur-3xl" />
    <div className="relative max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid lg:grid-cols-[0.9fr_1.1fr] gap-12 items-end mb-14">
        <Reveal>
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Por que a Gabibox</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white text-balance">
            Motivos que fazem de nós referência em vidros
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="text-white/70 leading-relaxed max-w-lg lg:justify-self-end">
            Cada projeto é tratado com precisão, materiais certificados e uma equipe que respeita prazos.
            Do orçamento sem compromisso à instalação final, você sente a diferença.
          </p>
        </Reveal>
      </div>

      <Stagger className="grid gap-px rounded-3xl overflow-hidden bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
        {DIFFERENTIALS.map((d, i) => {
          const Icon = Icons[d.icon] || Icons.Check;
          return (
            <StaggerItem key={d.title}>
              <div className="group h-full bg-[#012a60] p-8 transition-colors duration-500 hover:bg-[#06356f]">
                <div className="flex items-center justify-between mb-8">
                  <span className="grid place-items-center h-12 w-12 rounded-xl bg-white/10 text-[#55c0e0] transition-transform duration-500 group-hover:-translate-y-1 group-hover:bg-[#55c0e0] group-hover:text-[#012a60]">
                    <Icon size={22} />
                  </span>
                  <span className="font-display text-4xl font-black text-white/10">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <h3 className="font-display text-lg font-bold text-white">{d.title}</h3>
              </div>
            </StaggerItem>
          );
        })}
      </Stagger>
    </div>
  </section>
);
